import ClickDeliverConnector from './clickDeliver.props';
import ClickDeliverComponent from './clickDeliver.component';

export default ClickDeliverConnector(ClickDeliverComponent);
